import { ActionTree } from "vuex";
import { User } from "@scrile/api-provider/dist/api/UserProvider";
import { UserVerificationStatus } from "@scrile/api-provider/dist/api/UserVerificationProvider";
import { ACTION_TYPES, MUTATION_TYPES } from "@/store/const";
import providers from "@/lib/api";
import { LoginData } from "@/lib/authHelper";
import payments from "@/payments";
import { StateRoot } from "./state";

export const actions: ActionTree<StateRoot, StateRoot> = {
  async [ACTION_TYPES.LOGIN](context, data: LoginData) {
    context.commit(MUTATION_TYPES.SET_LOGIN_DATA, data);
    await Promise.all([context.dispatch(ACTION_TYPES.GET_VERIFICATION_STATUS, data.user)]);
  },
  async [ACTION_TYPES.LOGOUT](context) {
    await providers.LoginProvider.logout();
    context.commit(MUTATION_TYPES.LOGOUT);
  },
  async [ACTION_TYPES.GET_VERIFICATION_STATUS](context, user: User) {
    const userVerification = await providers.UserVerificationProvider.search({ data: { userIds: [user.id] } });
    let dataVerified = userVerification.result.find(i => i.userId === user.id);
    context.commit(
      MUTATION_TYPES.SET_USER_VERIFICATION_STATUS,
      dataVerified?.status ?? UserVerificationStatus.UNVERIFIED
    );
  },
  async [ACTION_TYPES.GET_SYSTEM_SETTINGS](context) {
    const [systemSettings, currentPaymentSystem] = await Promise.all([
      providers.SystemSettingsProvider.get(),
      providers.PaymentSystemsProvider.findForCreditCardAssignment(),
    ]);
    context.commit(MUTATION_TYPES.SET_STATE, {
      systemSettings,
      currentPaymentSystem,
      creditCardAllowed: payments.checkAllowStoreCard(currentPaymentSystem),
    });
    return systemSettings;
  },
};
